<template>
  <div>
    <el-card style="margin-bottom: 25px;border: none;box-shadow: none;"
      :class="isShow ? 'show_card' : 'show_card header-border'">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer" @click="changeShow">
        <span style="font-weight: bold;font-size: 14px;color: #636569">信息解释</span>
        <i class="el-icon-arrow-up" v-show="isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="展开介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!isShow"
          style="cursor: pointer;color: #1e6cb0;font-weight: bold;font-size: 14px;" title="折叠介绍">展开</i>
      </div>
      <el-descriptions v-show="isShow" style="margin-bottom: 0;font-size: 13px!important;" border :column="3"
        :labelStyle="{ width: '126px' }">
        <el-descriptions-item label="文件自动同步" :span="3">
          该数据从share服务器获取，每3小时同步一次
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <el-tabs v-model="activeName" @tab-click="changeTab('activeName')">
      <el-tab-pane name="TECHNICAL_INFORMATION" label="技术资料"></el-tab-pane>
      <el-tab-pane name="MARKETING_PROMOTION" label="市场资料"></el-tab-pane>
      <el-tab-pane name="SALES_TRAINING_INFORMATION" label="培训资料"></el-tab-pane>
      <el-tab-pane v-if="role !== 'TECH'" v-for="(info,index) in classList" :name="info" :label="info"
        :key="index"></el-tab-pane>
      <el-tab-pane name="updateLog" label="更新日志"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="activeTab1" @tab-click="changeTab('activeTab1')" v-if="activeName === 'TECHNICAL_INFORMATION'">
      <el-tab-pane v-for="(info,index) in Object.keys(typeList)" :name="info" :label="info"
        :key="activeName + info + index"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="activeTab2" @tab-click="changeTab('activeTab2')"
      v-if="activeName === 'TECHNICAL_INFORMATION' && !!activeTab1">
      <el-tab-pane v-for="(info,index) in typeList[activeTab1]" :name="info" :label="info"
        :key="activeName + info + index"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="activeTab" @tab-click="changeTab('activeTab')" v-if="activeName === 'SALES_TRAINING_INFORMATION'">
      <el-tab-pane v-for="(info, index) in trainingList" :name="info" :label="info"
        :key="activeName + info + index"></el-tab-pane>
    </el-tabs>
    <el-tabs v-model="activePromotion" @tab-click="changeTab('activePromotion')"
      v-if="activeName === 'MARKETING_PROMOTION'">
      <el-tab-pane v-for="(info, index) in promotionList" :name="info" :label="info"
        :key="activeName + info + index"></el-tab-pane>
    </el-tabs>
    <w-table ref="wMyTable" :columns="columns" :table-data="reportList" v-if="activeName!=='updateLog'"
      @getTableSearchSortCon="getTableSearchSortCon" :isPagination="true" :page="page"
      @pageChange="handlePagePagination">
      <div slot="operation" slot-scope="{text,record}">
        <a href="#" @click="handleDown(record['hexCode'])">
          <i class="el-icon-download"></i>
          <span v-if="record['reportName']&&record['reportName'].length>20">
            <el-tooltip :content="'下载 '+record['reportName']">
              <span>{{ record['reportName'].substring(0,20) }}...</span>
            </el-tooltip>
          </span>
          <span v-else>
            {{ record['reportName'] }}
          </span>
        </a>
      </div>
      <template slot="reportName" slot-scope="{text,record}">
        <span v-if="text">
          {{text}}
        </span>
        <span v-else>
          {{ record['fileName'] }}
        </span>
      </template>
    </w-table>
    <el-timeline v-if="activeName==='updateLog'">
      <el-timeline-item :color="item.size === 'large' ? '#409EFF': '#e4e7ed'" :size="item.size"
        :timestamp="item.updateTime" placement="top" v-for="(item,index) in logData" :key="index">
        <el-card>
          <h4 v-if="item['updateContent'] && item['updateContent'].length > 0">更新内容:</h4>
          <ul>
            <li class="logDetail" v-for="(itemInner,index) in item['updateContent']"><i
                class="iconfont icon-dian"></i>{{ itemInner }}
            </li>
          </ul>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <!--    图片加载-->
    <picture-loading v-if="loading"></picture-loading>
  </div>
</template>

<script>

import PictureLoading from "@/components/customerTable/PictureLoading";
import {getClassification, salesDataPage} from "@/api/dilivery/salesData";
import {salesData} from "@/utils/data/tableCol/salesData/salesData";
import {getMethodLog} from "@/api/dilivery/method";
import {getDataInLocalStorage} from "@/utils/localStorage";
import {techData} from "@/utils/data/tableCol/salesData/techData";
import { record } from "@/utils/data/tableCol/record/record";
const baseURL = process.env.VUE_APP_BASE_API
export default {
  name: "SalesData",
  components: {
    PictureLoading,
  },
  data() {
    return {
      role:'',
      isShow:true,
      reportList: [],
      classList:[],
      typeList:{},
      trainingList:[],
      // 分页参数
      page: {
        currentNum: 1,
        pageSize: 10,
        total: 0
      },
      sortConditionTag: [],
      searchConditionTag: [],
      loading: true,
      activeName: 'TECHNICAL_INFORMATION',
      activeTab1:'',
      activeTab2:'',
      activeTab:'',
      activePromotion:'',
      promotionList:[],
      logData:[]
    }
  },
  computed: {
    columns() {
      if(this.activeName === 'TECHNICAL_INFORMATION'){
        return JSON.parse(JSON.stringify(techData(this.searchConditionTag || {})))
      }else{
        return JSON.parse(JSON.stringify(salesData(this.searchConditionTag || {})))
      }
    },
  },

  created() {
    this.role = getDataInLocalStorage('role')
    this.getClassList()
  },
  methods: {
    changeTab(type) {
      if(this.activeName !== 'updateLog'){
        if(type === 'activeTab1'){
          this.activeTab2 = this.typeList[this.activeTab1][0]
        }
        this.getData(true)
      }else{
        this.getLogData()
      }
    },
    //获取报告模板更新日志
    getLogData() {
      this.loading = true
      let params = {
        updateLogType: 'SALES_INFO',
      };
      getMethodLog(params).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.logData = res.data.map(item => {
            return {
              ...item,
              size:'large'
            }
          })
          
        }
      }).catch(err => { this.loading = false })
    },
    getClassList() {
      for (let data of ['TECHNICAL_INFORMATION', 'SALES_TRAINING_INFORMATION','MARKETING_PROMOTION','SELL_GENERAL_INFORMATION']){
        let params = {
          type:data
        }
        getClassification(params).then(res => {
          if(res.code === 200){
            if (['TECHNICAL_INFORMATION'].includes(data)){
              this.typeList = res.data
              this.activeTab1 = Object.keys(res.data)[0]
              this.activeTab2 = this.typeList[this.activeTab1][0]
            } else if ('SALES_TRAINING_INFORMATION' === data) {
              this.trainingList = res.data
              this.activeTab = res.data[0]
            } else if ('MARKETING_PROMOTION' === data) {
              this.promotionList = res.data
              this.activePromotion = res.data[0]
            }else{
              this.classList = res.data
            }
            this.getData()
          }
        }).catch(err => {})
      }

    },
    changeShow() {
      this.isShow = !this.isShow
    },
    //获取报告模板数据列表
    getData(isResetPageCurrent) {
      this.loading = true
      if (this.classList.length === 0 || Object.keys(this.typeList).length === 0 || this.trainingList.length === 0){
        this.getClassList()
        return
      }
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      };
      if (isResetPageCurrent) {
        params = {
          'page.current': 1,
          'page.size': 10,
        }
      }
      let sendData = {}
      let type = ''
      if(this.activeName === 'TECHNICAL_INFORMATION'){
        sendData['classificationOne'] = this.activeTab1
        sendData['classificationTwo'] = this.activeTab2
        type = 'TECHNICAL_INFORMATION'
      } else if (this.activeName === 'SALES_TRAINING_INFORMATION'){
        sendData['classificationOne'] = this.activeTab
        type = 'SALES_TRAINING_INFORMATION'
      } else if (this.activeName === 'MARKETING_PROMOTION') {
        sendData['classificationOne'] = this.activePromotion
        type = 'MARKETING_PROMOTION'
      }else{
        sendData['classificationOne'] = this.activeName
        type = 'SELL_GENERAL_INFORMATION'
      }
      sendData['informationType'] = type
      if (this.searchConditionTag && this.searchConditionTag.length) {
        //遍历搜索条件的内容
        sendData = this.getSearch(sendData)
      }
      salesDataPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.reportList = res.data.records.map((item, index) => {
            return {
              ...item,
              id: ((parseInt(res.data.current)-1) * parseInt(res.data.size)) + index + 1
            }
          })
          // 分页赋值
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
        }
      }).catch(err => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      let data = {...sendData}
      this.searchConditionTag.forEach(item => {
        let key = item.key
        data[key] = item.value
      })
      return data
    },
    //获取表格搜索条件
    getTableSearchSortCon(searchConditionTag, sortConditionTag) {
      this.searchConditionTag = searchConditionTag
      this.sortConditionTag = sortConditionTag
      this.getData(true)
    },
    //分页
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    //下载模板
    async handleDown(hexCode) {
      try {
        let url = `${baseURL}/sales-data/download/${hexCode}/${getDataInLocalStorage("token")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
        this.$messageUi.error('下载附件失败')
      }
    }
  }
}
</script>

<style scoped>

h3 {
  margin-top: 0;
  font-size: 25px;
}

h4 {
  font-size: 16px;
}


.el-card ul li {
  margin-top: 5px;
  font-weight: 550;
  font-size: 14px;
  word-wrap: break-word;
}
</style>
